<template>
	<div>
		<modalpassword ref="modalpassword" @action="changePassword"></modalpassword>
		<div class="d-flex justify-space-between">
			<div class="text-h5">Profile</div>
		</div>
		<v-col cols="12" md="12" class="pa-0 mt-3">
			<v-card class="overflow-hidden" outlined>
				<v-card-text class="pb-0">
					<v-row>
						<v-col cols="5" md="2" class="text-center">
							<v-hover v-slot:default="{ hover }">
								<v-avatar color="grey" size="120">
									<img class="avatar" :src="userData.user_image">
									<v-expand-transition>
										<div v-if="hover" class="d-flex transition-fast-in-fast-out primary v-card--reveal white--text" style="height: 100%;">
											<v-file-input dark color="white" @change="handleFileUpload($event)" accept="image/png, image/jpeg, image/jpg" prepend-icon="mdi-camera" hide-input hide-details class="icon-upload-avatar-profile">
											</v-file-input>
										</div>
									</v-expand-transition>
								</v-avatar>
							</v-hover>
						</v-col>
						<v-col cols="7" md="10" class="text-center">
							<div class="mb-3 text-right">
								<v-btn dark depressed color="primary" @click="showModalPassword">
									<v-icon small class="pr-2">mdi-key</v-icon>
									Ubah Kata Sandi
								</v-btn>
							</div>
							<v-row>
								<v-col cols="12" md="6" class="text-center">
									<v-text-field disabled label="Username" v-model="userData.user_username" outlined dense></v-text-field>
								</v-col>
								<v-col cols="12" md="6" class="text-center">
									<v-text-field :disabled="!isEditing" label="Nama" v-model="name" outlined dense></v-text-field>
								</v-col>
								<v-col cols="12" md="6" class="text-center">
									<v-text-field :disabled="!isEditing" label="Nomor Handphone" v-model="mobilephone" outlined dense></v-text-field>
								</v-col>
								<v-col cols="12" md="6" class="text-center">
									<v-text-field :disabled="!isEditing" v-model="email" :rules="emailRules" label="E-mail" required outlined dense></v-text-field>
								</v-col>
								<v-col cols="12" md="6" class="text-center">
									<v-autocomplete disabled :items="OptionType" item-text="type_name" label="Tipe" v-model="userData.user_type" outlined dense no-data-text="Tidak ada data yang sesuai"></v-autocomplete>
								</v-col>
							</v-row>
						</v-col>
					</v-row>
				</v-card-text>
				<v-card-actions class="mx-2">
					<v-spacer></v-spacer>
					<v-btn dark outlined v-if="isEditing" color="grey darken-1" @click="batal">
						<v-icon small class="pr-2">mdi-close</v-icon>
						Batal
					</v-btn>
					<v-btn dark depressed v-if="isEditing" color="primary" @click="save">
						<v-icon small class="pr-2">mdi-check</v-icon>
						Simpan
					</v-btn>
					<v-btn dark depressed v-if="!isEditing" color="primary" @click="isEditing = !isEditing">
						<v-icon small class="pr-2">mdi-pencil</v-icon>
						Ubah
					</v-btn>
				</v-card-actions>
			</v-card>
		</v-col>
		<v-snackbar v-model="hasSaved" :timeout="2000" absolute top right color="light-blue">
			Your profile has been updated
		</v-snackbar>
	</div>
</template>

<script>
import {mapActions,  mapState, mapMutations} from 'vuex'
import modalpassword from '@/views/MLwarehouse/profile/ModalPasswordProfile'

export default {
	components: {
		modalpassword
	},
	data() {
		return {
			formData: new FormData(),
			image: '',
			hasSaved: false,
			isEditing: null,
			model: null,
			name: '',
			email: '',
			mobilephone: '',
			emailRules: [
			v => !!v || 'E-mail is required',
			v => /.+@.+/.test(v) || 'E-mail must be valid',
			],
		}
	},
	computed: {
		...mapState('auth', ['userData']),
		...mapState('userList', ['OptionType', 'responSukses']),
	},
	methods: {
		...mapActions('userList', ['getTypeOption', 'updatePassword', 'changeImage', 'update']),
		...mapMutations('userList', ['clearDataUser', 'konfirmasiSukses']),

		handleFileUpload(event) {
			this.formData.append('image', event);
			this.changeImage(this.formData).then( () => {
				if (this.responSukses.code == 200) {
					this.konfirmasiSukses({})
					// this.image = this.imageName
				}
			})
		},
		showModalPassword(){
			this.$refs.modalpassword.show()
		},
		changePassword(params) {
			this.updatePassword(params).then(() => {
				if (this.responSukses.code == 200) {
					this.konfirmasiSukses({})
					this.$refs.modalpassword.hide()
				}
			})
		},
		batal() {
			this.isEditing = !this.isEditing
			this.setDataToUserData()
		},
		save () {
			this.isEditing = !this.isEditing
			let params = {
				id : this.userData.user_id,
				name : this.name,
				email : this.email,
				mobilephone : this.mobilephone,
				type : this.userData.user_type,
				privilege : JSON.stringify(this.userData.user_privilege),
			}
			this.update(params)
		},
		setDataToUserData(){
			this.name = this.userData.user_name
			this.email = this.userData.user_email
			this.mobilephone = this.userData.user_mobilephone
		}
	},
	created() {
		this.$store.dispatch('setPageTitle', `Profil`)
		this.getTypeOption()
		this.setDataToUserData()
	},
	beforeDestroy(){
		this.clearDataUser()
	}
}
</script>